import {
  AfterViewInit,
  Component,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';

@Component({
  selector: 'app-text-box-editor',
  templateUrl: './text-box-editor.component.html',
  styleUrls: ['./text-box-editor.component.scss']
})
export class TextBoxEditorComponent
  implements ICellEditorAngularComp, AfterViewInit
{
  @ViewChild('input', { read: ViewContainerRef })
  public input: ViewContainerRef;
  public columnId: string;
  public formGroup: FormGroup;

  public ngAfterViewInit(): void {
    setTimeout(_ => {
      this.input.element.nativeElement.select();
    }, 0);
  }

  public agInit(
    params: ICellEditorParams & { context: { form: FormGroup } }
  ): void {
    this.columnId = params.column.getColId();
    this.formGroup = params.context.form;
  }

  public getValue(): string {
    return this.formGroup.get(this.columnId).value;
  }
}
